import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';
import { defaultDataTypes as getDefaultDataTypes } from '../../../../components/Common/Utils/defaultDataTypes.js';
import { withStyles } from '@material-ui/core';
import LibrarySectionList from '../LibrarySectionList'
import DataType from './DataType'
import { chunk } from '../../../../../utils/commonHelpers';
import { showSnackbar } from '../../../../../actions/appActions.js';
import { librarySections } from '../../../../../utils/library/librarySections.js';
import NoItemsPlaceholder from '../NoItemsPlaceholder/NoItemsPlaceholder';

const HEIGHT_NO_ITEMS = 150
const HEIGHT_CONTAINER = 440

const styles = theme => ({
    allDataTypesContainer: {
        height: HEIGHT_CONTAINER,
        width: 1286,
        backgroundColor: '#f5f5f5',
        marginTop: 48,
        marginRight: 'auto',
        marginLeft: 'auto',
    },
    headerSection: {
        height: 70,
        display: 'flex',
        flexDirection: 'row',
    },
    titles: {
        flexDirection: 'column',
        marginRight: 'auto'
    },
    title: {
        fontFamily: 'Rubik',
        fontSize: 32,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#21212d',
    },
    subtitle: {
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.75,
        letterSpacing: 'normal',
        color: '#a3a3a3',
    },
    controlButtons: {
        flexDirection: 'column',
        alignSelf: 'center',
        border: 'solid 2px #e0e0e0',
        borderRadius: 4,
        width: 84,
        height: 38,
    },
    allDataTypes: {
        marginTop: (46 + 14) * -1,
        display: 'grid',
        gridTemplateColumns: 'auto auto auto auto auto auto'
    },
    disableIcon:{
        fill: theme.newUI.color.gray
    },
    activeIcon:{
        cursor: 'pointer',
        fill: theme.newUI.color.commonBlack
    },
    leftButton: {
        width: 42,
        height: 38,
        background: 'none',
        border: 'none',
    },
    rightButton: {
        width: 42,
        height: 38,
        borderRadius: 4,
        background: 'none',
        border: 'none',
        borderLeft: 'solid 0.5px #e0e0e0',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    controlWrap: {
        width: 1286,
        top: 0,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    listContainer: {
        width: 1286,
        height: 440,
        alignItems: 'end'
    },
    cardsContainer: {
        position: 'absolute',
        top: 60,
    },
});


const SCREEN_ITEMS = 6
const defaultDataTypes = getDefaultDataTypes()

const getAllDataTypes = (inputMappings) => {

    const allDataTypesColors = ['#4145d3', '#3ece5a', '#00caeb', '#ffb632', '#a654c6', '#f3d20b']

    const types = defaultDataTypes.concat(inputMappings)
    const datatypes = types.filter(type => !!(type.title && type.icon)).map((type, i) => ({title: type.title, description: type.description, icon: type.icon, tag: type.customDataMapping.dataTypeFilter}))
    const chunks = chunk(SCREEN_ITEMS, datatypes)
    return chunks.reduce((accum, chunk) => [...accum, ...chunk.map((group, i) => ({...group, backgroundColor: allDataTypesColors[i]}))], [])
}

const AllDataTypes = (props) => {
    const {classes, inputMappings, profileData} = props

    const [allDataTypes, setAllDataTypes] = useState([])
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        setAllDataTypes(getAllDataTypes(inputMappings, profileData.org.brandingColor))
    }, [inputMappings])

    const subscribe = (tagInfo, goToDatatype) => {
        if(isLoading) return
        const { userSettingsService, dispatch } = props;
        setIsLoading(true)
        dispatch(showSnackbar('subscribing...'));
        userSettingsService
        .subscribe(tagInfo)
        .then((_) => {
            userSettingsService.getUserData().then((userData) => {
                dispatch(showSnackbar('Subscribed successfully!'));
                dispatch({
                    type: 'USER_DATA_LOAD', data: {
                        ...userData
                    }
                });
                setIsLoading(false)
                goToDatatype()
            })
        });
    }

    const Header = (
        <div data-intrcm-id="AllDataTypes_xku0o6fr" className={classes.title}>{librarySections().dataTypes.title}</div>
    )
    const SubHeader = (
        <div data-intrcm-id="AllDataTypes_b64yizq5" className={classes.subtitle}>{librarySections().dataTypes.subtitle}</div>
    )
    const controlStyles = {
        controlWrap: classes.controlWrap,
        controlButtons: classes.controlButtons,
        leftButton: classes.leftButton,
        rightButton: classes.rightButton,
        activeIcon: classes.activeIcon,
        disableIcon: classes.disableIcon,
        arrowBg: 'transparent'
    }

        return (
            <div data-intrcm-id="AllDataTypes_052zjzvg" style={{height: allDataTypes.length === 0 ? HEIGHT_NO_ITEMS : HEIGHT_CONTAINER}} className={classes.allDataTypesContainer}>
              <div data-intrcm-id="AllDataTypes_r7g3spzg" className={classes.headerSection} >
                <div data-intrcm-id="AllDataTypes_3gtd0knd" className={classes.titles}>
                    {Header}
                    {SubHeader}
                </div>
              </div>
              {allDataTypes.length === 0 &&
                <NoItemsPlaceholder placeholder={"No data types available"} />
              }
              <div data-intrcm-id="AllDataTypes_eq9i1gd6" className={classes.allDataTypes}>
              {allDataTypes.length > 0 &&
               <LibrarySectionList screenSize={SCREEN_ITEMS} listContainerStyle={classes.listContainer} cardsContainerStyle={classes.cardsContainer} controlStyles={controlStyles} >
                {allDataTypes.map((dataType, i) => (
                    <DataType key={i} dataType={dataType} subscribe={subscribe} />
                ))}
                </LibrarySectionList>
              }
              </div>
            </div>
        )
}

const mapStateToProps = (state) => ({
    inputMappings: state.globalData.inputMappings,
    userSettingsService: state.services.userSettingsService,
    userData: state.userData,
    profileData: state.userData.profileData,
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps))(AllDataTypes);